<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('payment.title') }}
        <Bookmark service_type_code='6424' />
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('payment.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list')}}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">

          <div class="top__component__fold__wrap" v-if="component_fold">

            <!-- 상단 검색 영역 : S -->
            <v-row class="top_search_content2">
              <v-col cols="12" md="4" class="pb-0">
                <label class="nec_title">{{ $t('payment.fields.fee_name') }}</label>
                <div class="input_text_type_basic2">
                  <v-select
                    dense
                    outlined
                    hide-details
                    class="ft-size12"
                    :items="$vuetify.rtl ? feeNameCodeListAr : feeNameCodeListEn"
                    v-model="search_fee_config_seq"
                  >
                  </v-select>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="pb-0">
                <label class="nec_title">{{ $t('payment.fields.fee_status') }}</label>
                <div class="input_text_type_basic2">
                  <v-select
                    dense
                    outlined
                    hide-details
                    class="ft-size12"
                    :items="$vuetify.rtl ? feeStatusCodeListAr : feeStatusCodeListEn"
                    v-model="search_fee_status_code"
                  >
                  </v-select>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="pb-0">
                <label class="nec_title">{{ $t('payment.fields.applicant') }}</label>
                <div class="input_text_type_basic2">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    class="ft-size12"
                    v-model="search_applicant"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="8" class="pb-0">
                <label class="nec_title">{{ $t('payment.fields.date') }}</label>
                <v-row>
                  <v-col cols="12" class="d-flex align-center pt-0 pb-0">
                    <div class="input_text_type_basic2 wp50">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            outlined
                            solo
                            dense
                            flat
                            placeholder="DD/MM/YYYY"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            class="date_type"
                            v-model="viewDate1"
                            @click:append="menu1 = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" no-title @input="fnSetStartDate()"></v-date-picker>
                      </v-menu>
                    </div>

                    <v-spacer class="hidden_lr5">~</v-spacer>

                    <div class="input_text_type_basic2 wp50">
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            outlined
                            solo
                            dense
                            flat
                            placeholder="DD/MM/YYYY"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            class="date_type"
                            v-model="viewDate2"
                            @click:append="menu2 = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker :min="date1" v-model="date2" no-title @input="fnSetEndDate()"></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" class="pb-0">
                <label class="nec_title">{{ $t('payment.fields.application_no') }}</label>
                <div class="input_text_type_basic2">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    class="ft-size12"
                    v-model="search_application_no"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('payment.fields.receipt_no') }}</label>
                <div class="input_text_type_basic2">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    class="ft-size12"
                    v-model="search_receipt_no"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('payment.fields.pct_application_no') }}</label>
                <div class="input_text_type_basic2">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    class="ft-size12"
                    v-model="search_pct_application_no"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="mobile__dcolumn d-flex">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dark @click="fnGetDataFromApi(1)">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dark @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>
            <!-- 상단 검색 영역 : E -->

          </div>

          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->

          <v-row class="mt-25">
            <v-col cols="12">
              <div class="data_table_html_type">
                <v-data-table
                  :headers="$getHeaderType2(headerTxt, headers_en, headers_ar)"
                  :items="requestList"
                  :custom-sort="$customSort"
                  must-sort
                  hide-default-footer
                  class="new__type__table"
                  :mobile-breakpoint="MobileBreakPoint"
                  v-model="selected"
                  item-key="payment_item_seq"
                  :options.sync="options"
                  :server-items-length="paging.totalCount"
                >
                  <template v-slot:header.application_no="{ header }">
                    {{ $t('payment.fields.application_no') }}
                    <br />
                    ({{ $t('payment.fields.receiving_no') }})
                  </template>

                  <template v-slot:item.payment_item_seq="{ item }">
                    <div style="text-align:center" >
                      <v-checkbox
                        v-model="selected"
                        :value="item.payment_item_seq"
                        :disabled="item.payment_status_type_code != '1602'"
                        class="mt-0 pt-0 view__chkbox ty2"
                        style="height: 20px;"
                      ></v-checkbox>
                    </div>
                  </template>
                  <template v-slot:item.application_no="{ item }">
                    <div>{{ item.application_no }}</div>
                    <div v-if="item.reference_type_code === '4602'">({{ item.reference_no }})</div>
                  </template>
                  <template v-slot:item.applicant_type_code="{ item }">
                    <v-icon>{{fnParseApplicantTypeCodeIcon(item.applicant_type_code)}}</v-icon> {{$vuetify.rtl ? item.applicant_type_name_ar : item.applicant_type_name_en}}
                  </template>
                  <template v-slot:item.fee_name_en="{ item }">
                    {{item.fee_name_en}}
                    <v-badge :content="'+'+ (item.cnt - 1)" v-if="item.cnt > 1" class="pl-1"></v-badge>
                  </template>
                  <template v-slot:item.fee_name_ar="{ item }">
                    {{item.fee_name_ar}}
                    <v-badge :content="'+'+ (item.cnt - 1)" v-if="item.cnt > 1" class="pl-1"></v-badge>
                  </template>
                  <template v-slot:item.total_amount="{ item }">
                    {{item.total_amount | comma}}
                  </template>
                  <template v-slot:item.receipt_no="{ item }">
                    <v-chip v-if="item.payment_status_type_code === '1602'" dark color="#98bbbf" @click="fnShowInvoice(item)">{{$t('common.button.pay')}}</v-chip>
                    <v-icon v-if="item.receipt_no !== ''" style="cursor : pointer;" @click="fnGetReceipt(item)">{{'mdi-file'}}</v-icon>
                  </template>
                </v-data-table>

                <div class="v-data-table board_basic_wrap theme--light mb-30 mt-0">
                  <div class="v-data-table-footer page_nation_wrap">
                    <ServerPagination
                      :paging.sync="paging"
                      @page="fnGoPage"
                      @pageSize="fnSetPageSize"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>


          <v-row>
            <v-col cols="12" class="d-flex">
              <v-spacer></v-spacer>
              <v-btn
                dense
                height="50"
                width="150"
                class="capitalize btn_basic btn-actv br_none"
                @click="fnShowInvoiceList()"
              >
                {{ $t('payment.fields.pay_selected_fee') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>

    <DialogInvoice
      :prop_dialog_invoice="dialog_invoice"
      :prop_invoiceList="invoiceList"
      :query="$route.query"
      :prop_selected.sync="selected"
      @close="fnCloseDialogInvoice"
      @error="fnSetDialog"
      @success="fnCloseDialogInvoiceAndSearch">
    </DialogInvoice>
    <DialogReceipt
      :prop_dialog_receipt="dialog_receipt"
      :prop_receipt="receipt"
      @close="fnCloseDialogReceipt">
    </DialogReceipt>

  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import ServerPagination from '@/components/layout/ServerPagination'
import DialogInvoice from '@/components/layout/DialogInvoice'
import DialogReceipt from '@/components/layout/DialogReceipt'
import Bookmark from '@/components/layout/Bookmark'

export default {
  name : "PaymentList",
  components :{
    Bookmark,
    ServerPagination,
    DialogInvoice,
    DialogReceipt
  },
  data: (function(vm){
    return {
      MobileBreakPoint:0,
      component_fold:false,
      id: 'PaymentList',
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      date1: null,
      date2: null,
      viewDate1 : '',
      viewDate2 : '',
      menu1: false,
      menu2: false,
      dialog_enter : false,

      headerTxt : {
        prefix : 'payment.fields.',
        txt : [ '', 'application_no','fee','due_date','paid_date','applicant_type','amount','receipt' ]
      },
      headers_ar: [
        { text: '', align: 'center', value: 'payment_item_seq', width:'50'},
        { text: 'Application No', align: 'center', value: 'application_no', width: '120' },
        { text: 'Fee', align: 'center', value: 'fee_name_ar' },
        { text: 'Due Date', align: 'center', value: 'due_date', width: '100' },
        { text: 'Paid Date', align: 'center', value: 'paid_date', width: '100' },
        { text: 'Applicant Type', align: 'center', value: 'applicant_type_code', width: '120' },
        { text: 'Amount', align: 'center', value: 'total_amount', width: '100' },
        { text: 'Receipt', align: 'center', value: 'receipt_no', width: '100' },
      ],
      headers_en: [
        { text: '', align: 'center', value: 'payment_item_seq', width:'50'},
        { text: 'Application No', align: 'center', value: 'application_no', width: '120' },
        { text: 'Fee', align: 'center', value: 'fee_name_en' },
        { text: 'Due Date', align: 'center', value: 'due_date', width: '100' },
        { text: 'Paid Date', align: 'center', value: 'paid_date', width: '100' },
        { text: 'Applicant Type', align: 'center', value: 'applicant_type_code', width: '120' },
        { text: 'Amount', align: 'center', value: 'total_amount', width: '100' },
        { text: 'Receipt', align: 'center', value: 'receipt_no', width: '100' },
      ],
      feeStatusCodeListAr: [],
      feeStatusCodeListEn: [],
      feeNameCodeListAr : [],
      feeNameCodeListEn : [],
      search_fee_status_code : '',
      search_fee_config_seq : '',
      search_applicant : '',
      search_start_date : '',
      search_end_date : '',
      search_application_no : '',
      search_receipt_no : '',
      search_pct_application_no : '',
      requestList : [],
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
      options: {},
      selected: [],
      dialog_invoice: false,
      dialog_receipt: false,
      invoiceList: [],
      receipt: {},
      receipt_no: '',
      searchParams: {}
    }
  }),
  watch : {
    options: {
      handler () {
        this.fnGetDataFromApi()
      },
      deep: true,
    },
    requestList : {
      deep: true,
      handler() {
        this.selected = []
      }
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created () {
    this.search_fee_status_code = (this.$route.query.search_fee_status_code) ? this.$route.query.search_fee_status_code : ''
    // due date 에서 넘어왔을 때
    this.search_application_no = (this.$route.query.search_application_no) ? this.$route.query.search_application_no : ''

    this.search_receipt_no = (this.$route.query.search_receipt_no) ? this.$route.query.search_receipt_no : ''
  },
  mounted(){
    window.scrollTo(0, 0)
     // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })

    this.fnGetFeeStatusCodeList()
    this.fnGetFeeNameCodeList()
    this.fnGetDataFromApi(1)
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    //검색 - Fee Status 조회
    fnGetFeeStatusCodeList() {
      let options = {
        upper_code: '1600',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.feeStatusCodeListAr = list.ar
        this.feeStatusCodeListEn = list.en
      })
    },

    //검색 - Fee Name 조회
    fnGetFeeNameCodeList() {
      this.feeNameCodeListAr = [{ text : 'جميع', value : '' }]
      this.feeNameCodeListEn = [{ text: 'All', value: ''}]

      requestApi({
        url: '/config/fees',
        method: 'GET',
        data: {},
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.list.length > 0){
              res.data.list.forEach(item => {
                let optionsAr = {
                  text : item.name_ar,
                  value : item.seq
                }
                let optionsEn = {
                  text: item.name_en,
                  value: item.seq
                }
                this.feeNameCodeListAr.push(optionsAr)
                this.feeNameCodeListEn.push(optionsEn)
              })
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFeeNameCodeList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnReset(){
      this.search_fee_config_seq = ''
      this.search_fee_status_code = ''
      this.search_application_no = ''
      this.search_start_date = ''
      this.search_end_date = ''
      this.search_applicant = ''
      this.search_receipt_no = ''
      this.search_pct_application_no = ''

      this.options.sortBy = []
      this.options.sortDesc = []

      this.searchParams = {}

      if (this.options.page === 1 && this.options.itemsPerPage === 10) {
        this.fnGetDataFromApi(1)
      } else {
        this.options.page = 1
        this.options.itemsPerPage = 10
      }
    },

    fnGoPage(paging) {
      this.options.page = paging.page
    },

    fnSetPageSize(paging) {
      // 페이지당 목록 개수를 변경할 경우에는 1페이지로 이동
      this.options.page = 1
      this.options.itemsPerPage = paging.pageSize
    },

    fnGetDataFromApi (page) {
      if (page) {
        this.options.page = page
        if (page === 1) {
          this.searchParams = {}
        }
      }
      this.fnSearch().then(list => {
        this.requestList = list
        this.paging.totalCount = 0
        if (list.length > 0) {
          this.paging.totalCount = list[0].total_cnt
        }
        this.paging.pageCount = parseInt((this.paging.totalCount - 1) / this.options.itemsPerPage, 10) + 1
      }).catch(() => {
        this.searchParams = {}
        this.fnGetDataFromApi(page)
      })
    },

    //목록
    fnSearch() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        this.paging.page = this.options.page

        let params = {
          page: this.options.page,
          page_size: this.options.itemsPerPage,
          sort_by: (this.options.sortBy.length > 0) ? this.options.sortBy[0] : '',
          sort_desc: (this.options.sortDesc.length > 0) ? this.options.sortDesc[0] : ''
        }

        if(this.search_fee_config_seq != ''){
          params.search_fee_config_seq = this.search_fee_config_seq
        }
        if(this.search_fee_status_code != ''){
          params.search_fee_status_code = this.search_fee_status_code
        }
        if(this.search_application_no != ''){
          params.search_application_no = this.search_application_no
        }
        if(this.search_start_date != '' && this.search_end_date != ''){
          params.search_start_date = this.search_start_date
          params.search_end_date = this.search_end_date
        }
        if(this.search_applicant != ''){
          params.search_applicant = this.search_applicant
        }
        if(this.search_receipt_no != ''){
          params.search_receipt_no = this.search_receipt_no
        }
        if(this.search_pct_application_no != ''){
          params.search_pct_application_no = this.search_pct_application_no
        }

        if (Object.entries(params).toString() === Object.entries(this.searchParams).toString()) {
          return false
        }

        this.searchParams = params

        requestApi({
          url: '/payments',
          method: 'GET',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].no = res.data.list.length - i
              }

              resolve(res.data.list)
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  reject()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      })
    },
    fnSetStartDate(){
      this.viewDate1 = this.formatViewDate(this.date1)
      this.menu1 = false
      // 저장객체에 날짜 세팅
      this.search_start_date = this.formatDate(this.date1)

      this.fnSetMinDate()
    },
    fnSetEndDate(){
      this.viewDate2 = this.formatViewDate(this.date2)
      this.menu2 = false
      // 저장객체에 날짜 세팅
      this.search_end_date = this.formatDate(this.date2)
    },
    fnSetMinDate(){
      if(!utils.isNull(this.date2)){
        let start = this.date1.split('-')
        let end   = this.date2.split('-')

        let startDate = new Date()
        startDate.setFullYear(start[0])
        startDate.setMonth(Number(start[1]) - 1)
        startDate.setDate(start[2])

        let endDate = new Date()
        endDate.setFullYear(end[0])
        endDate.setMonth(Number(end[1]) - 1)
        endDate.setDate(end[2])

        if(endDate < startDate){
          this.date2 = this.date1
          this.viewDate2 = this.formatViewDate(this.date1)
          this.search_end_date = this.formatDate(this.date1)
        }
      }
    },
    formatViewDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return ''
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getColor (colorbadge) {
        if (colorbadge === 'Important') return '#b22325'
        else if (colorbadge === 'Warning') return '#f59a41'
        else if (colorbadge === 'Inactive') return '#c1c1c1'
        else if (colorbadge === 'Active') return '#99bc44'
        else if (colorbadge === 'Success') return '#00af50'
        else if (colorbadge === 'In Progress') return '#333'
        else if (colorbadge === 'Complete') return '#2a58ad'
        else if (colorbadge === 'Failure') return '#c1c1c1'
        else if (colorbadge === 'claim') return '#a01c2a'
        else if (colorbadge === 'smd') return '#a2c1e2'
        else if (colorbadge === 'pay') return '#98bbbf'

        else return '#1f94a6'
    },
    fnParseApplicantTypeCodeIcon(applicant_type_code){
      let result = ''

      if(applicant_type_code == '2701'){
        result = 'mdi-domain'
      }else if(applicant_type_code == '2702'){
        result = 'mdi-domain'
      }else if(applicant_type_code == '2703'){
        result = ''
      }else if(applicant_type_code == '2704'){
        result = 'mdi-account'
      }else if(applicant_type_code == '2705'){
        result = 'mdi-account'
      }else if(applicant_type_code == '2706'){
        result = ''
      }

      return result
    },
    fnShowInvoice(item) {
      let params = ''
      if(item.payment_item_seq !== ''){
        params += '?seqs='+item.payment_item_seq
      }

      requestApi({
        url: '/receivings/invoices'+ params,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.invoiceList = res.data.list
            this.dialog_invoice = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowInvoice(item)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnShowInvoiceList() {
      let params = ''

      if(this.selected.length == 0){
        let snackBarOptions = {
          text: '결제하실 목록을 선택해주세요.'
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      for (let i = 0; i < this.selected.length; i++) {
        params += (i == 0 ? '?seqs=' : '&seqs=' ) + this.selected[i]
      }

      requestApi({
        url: '/receivings/invoices'+ params,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.invoiceList = res.data.list
            this.dialog_invoice = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowInvoiceList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetReceipt(item) {
      if (!item.payment_history_seq || !item.payment_item_seq) {
        return
      }

      this.receipt = {}
      let params = {
        payment_history_seq: item.payment_history_seq,
        payment_item_seq: item.payment_item_seq
      }
      requestApi({
         url: '/receivings/receipt',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.receipt = res.data
            this.dialog_receipt = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt(item)
              })
            } else {
              store.dispatch('SetInitRequestApi')
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCloseDialogInvoice() {
      this.dialog_invoice = false
    },

    fnCloseDialogReceipt() {
      this.dialog_receipt = false
    },

    selectAllToggle(props) {
       if(this.selected.length != this.desserts.length - this.disabledCount) {
         this.selected = []
         const self = this;
         props.items.forEach(item => {
           if(!item.disabled) {
             self.selected.push(item)
           }
         });
       } else {
         this.selected = []
       }
    },

    fnSetDialog(option) {
      this.$router.push(option.path)
      eventBus.$emit('SHOW_DIALOG', option)
    },

    fnCloseDialogInvoiceAndSearch() {
      this.fnCloseDialogInvoice()
      this.fnGetDataFromApi(1)
    }
  }
}
</script>